import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyEasyEaseIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.357 21.189L14.317 12.31C14.173 12.128 14.173 11.871 14.317 11.689L21.357 2.80999C21.617 2.48199 21.383 1.99899 20.965 1.99899H3.035C2.617 1.99899 2.383 2.48199 2.643 2.80999L9.683 11.689C9.827 11.871 9.827 12.128 9.683 12.31L2.643 21.189C2.383 21.517 2.617 22 3.035 22H20.966C21.384 22 21.617 21.517 21.357 21.189Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyEasyEaseIcon.displayName = 'TimeDkeyEasyEaseIcon';
